import React from 'react';
import { Button } from './ui/button';
import { Phone, MessageCircle, Award } from 'lucide-react';
import { images, contactInfo } from '../mockData';

export const Hero = ({ t }) => {
  const handleWhatsApp = () => {
    const url = `https://wa.me/91${contactInfo.phone}?text=${encodeURIComponent(contactInfo.whatsappMessage)}`;
    window.open(url, '_blank');
  };

  const handleCall = () => {
    window.location.href = `tel:+91${contactInfo.phone}`;
  };

  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          role="img"
          aria-label="Fresh milk drop falling — RajDarshan Tandon Dairy delivers pure A2 cow and buffalo milk in Raipur daily"
          title="Farm-fresh pure milk delivery in Raipur — RajDarshan Tandon Dairy since 1969"
          className="w-full h-full object-cover"
        >
          <source src="/milkdropCOMPRESSED.mp4" type="video/mp4" />
        </video>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-brand-pink/90 text-white px-4 py-2 rounded-full mb-6 backdrop-blur-sm">
            <Award className="h-5 w-5" />
            <span className="font-semibold tracking-wide">{t.heroHighlight}</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold font-serif text-[#1A4A8F] mb-6 leading-tight drop-shadow-md">
            {t.heroTitle}
          </h1>

          {/* Subtitle */}
          <p className="text-lg sm:text-xl text-[#1A4A8F] font-semibold mb-8 leading-relaxed max-w-2xl">
            {t.heroSubtitle}
          </p>

        </div>
      </div>

      {/* Decorative Elements */}
    </section >
  );
};
